<script setup lang="ts">

import { computed } from "vue";
import { WorkOrderType } from "@domain/CarePlan/WorkOrders/WorkOrderType";
import type { ICarbucksProtectFeature } from "@domain/CarePlan";
import * as Icons from "./ProductIcons";

type Props = {
    model: ICarbucksProtectFeature
}

const { model } = defineProps<Props>();

const tyreRepair = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.TyreRepair ) );
const tyreReplacement = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.TyreReplacement ) );
const battery = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.BatteryReplacement ) );
const brakes = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.BrakeService ) );
const wiperBlades = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.WiperBladeReplacement ) );
const keyFob = computed( () => model.workOrderConfigurations.find( x => x.type == WorkOrderType.KeyFobService ) );

</script>

<template>

    <div class="flex flex-wrap justify-center tracking-wider w-full
                text-sm 3xl:text-xl">
    
        <div v-if="wiperBlades != null"
             class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.Wipers class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>Wiper<br/>Blades</h1>
        </div>
        <div v-if="battery != null"
             class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.Battery class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>12 Volt<br/>Battery</h1>
        </div>
        <div v-if="brakes != null"
             class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.Brakes class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>Brake<br/>Safety</h1>
        </div>
        <div v-if="keyFob != null"
             class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.KeyFob class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>Key Fob<br/>Repair</h1>
        </div>
        <div v-if="tyreReplacement != null || tyreRepair != null"
             class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.Tyres class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>Tyre<br/>Safety</h1>
        </div>
        <div class="basis-1/3 flex flex-col mb-4 items-center justify-center aspect-square text-center uppercase">
            <Icons.Concierge class="p-1 text-primary-500 opacity-80 mb-2 w-full 3xl:scale-150 3xl:mb-5" />
            <h1>Concierge<br/>Service</h1>
        </div>
        
    </div>

</template>